module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL2-if-correct.96c393af.mp3";